import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 49"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M24 4.5c-11.047 0-20 8.954-20 20 0 11.047 8.954 20 20 20 11.047 0 20-8.953 20-20s-8.953-20-20-20Zm-9.153 29.902c.322.13.681.13 1.003.002l4.473-1.783c.317-.126.604-.315.844-.556l11.91-11.91a3.31 3.31 0 0 0-.285-4.923 3.235 3.235 0 0 0-1.625-.699 3.356 3.356 0 0 0-2.849.952l-1.62 1.617a.5.5 0 0 0-.058.05 4.34 4.34 0 0 0-.133.14L16.445 27.34a2.502 2.502 0 0 0-.552.836l-1.795 4.472a1.35 1.35 0 0 0 .75 1.755Zm3.046-7.096 7.772-7.76c.01.839.335 1.674.975 2.313a3.317 3.317 0 0 0 2.343.975l-7.736 7.736a.501.501 0 0 0-.107.082 2.328 2.328 0 0 1-3.293-3.293.513.513 0 0 0 .046-.053Zm12.747-6.154a.497.497 0 0 1 .105-.08l.067-.067h-.068a3.25 3.25 0 0 1-3.25-3.25v-.034l-.257.257a2.329 2.329 0 0 0 3.403 3.174Zm.439-5.622a2.35 2.35 0 0 1 1.062.462 2.25 2.25 0 1 1-1.063-.462Zm-15.6 17.945 3.149-1.255a3.313 3.313 0 0 1-1.488-.86 3.314 3.314 0 0 1-.857-1.473l-1.258 3.132a.35.35 0 0 0 .455.456Z",
      clipRule: "evenodd"
    }
  )
);
var SvgDraftCircleFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var DraftCircleFilled_default = SvgDraftCircleFilled;

export { DraftCircleFilled_default as default };
